export default "__VITE_ASSET__Dhp29ddM__"